// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-3b28083c] {\n  color: #333333;\n  padding: 0;\n  margin: 0;\n  font-size: 21px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}", ""]);
// Exports
module.exports = exports;
